import { Component, EventEmitter, Input, OnInit, OnDestroy, Output } from '@angular/core';
import { Store } from '@ngxs/store';
import { Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { Profile } from 'src/app/models/profile.model';
import { TranslationService } from '../../../services/translation.service';
import { AccountService } from '../../../services/apis/account.service';
import { BusinessSignalrService } from '../../../services/signalr.service';
import { LoadMenu } from '../../../store-ngxs/actions/menu.actions';
import { NotificationState } from '../../../store-ngxs/states/notification.state';
import {
  LoadNotifications,
  LoadUnreadCount,
  ReceiveRealtimeNotification,
} from '../../../store-ngxs/actions/notification.actions';
import { UserNotification } from '../../../models/notification.model';
import { LabelKeys } from '../../../models/enums/label-keys';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-vertical-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class VerticalHeaderComponent implements OnInit, OnDestroy {
  notifKeys = LabelKeys.notifications;
  @Input() profile: Profile;
  @Input() secondaryNavigation: any[] = [];
  @Input() showToggle = true;
  @Input() hideMenuToggle = true;
  @Input() toggleChecked = false;
  @Output() toggleMobileNav = new EventEmitter<void>();
  @Output() toggleMobileFilterNav = new EventEmitter<void>();
  @Output() toggleCollapsed = new EventEmitter<void>();

  showFiller = false;
  private languageKey = 'language';

  public languages: any[] = [
    {
      language: 'English',
      code: 'en',
      type: 'US',
      icon: '/assets/images/flag/icon-flag-en.svg',
    },
    {
      language: 'Romana',
      code: 'ro',
      icon: '/assets/images/flag/icon-flag-ro.svg',
    },
  ];
  public selectedLanguage: any = this.languages[0];

  unreadCount$: Observable<number>;
  latestNotifications$: Observable<UserNotification[]>;
  private signalrSub: Subscription;

  constructor(
    private store: Store,
    private translationService: TranslationService,
    private accountService: AccountService,
    private authService: AuthService,
    private signalrService: BusinessSignalrService,
    private router: Router
  ) {
    this.unreadCount$ = this.store.select(NotificationState.getUnreadCount);
    this.latestNotifications$ = this.store.select(NotificationState.getLatestNotifications);
  }
  ngOnInit(): void {
    var localStorageLanguage = localStorage.getItem(this.languageKey);
    if (!localStorageLanguage) {
      this.accountService.getProfile().subscribe((profile) => {
        if (profile) {
          localStorage.setItem(this.languageKey, profile.userLanguage);
          localStorageLanguage = profile.userLanguage;
        } else {
          localStorage.setItem(this.languageKey, this.selectedLanguage.code);
          localStorageLanguage = this.selectedLanguage.code;
        }
        this.setCurrentLanguage(localStorageLanguage!);
      });
    } else {
      this.setCurrentLanguage(localStorageLanguage);
    }

    // Load notifications
    this.store.dispatch(new LoadUnreadCount());
    this.store.dispatch(new LoadNotifications({ page: 1, pageSize: 5 }));

    this.signalrSub = this.signalrService.notificationReceived.subscribe(
      (notification) => {
        if (notification) {
          this.store.dispatch(new ReceiveRealtimeNotification(notification));
        }
      }
    );
  }

  ngOnDestroy(): void {
    if (this.signalrSub) {
      this.signalrSub.unsubscribe();
    }
  }

  setCurrentLanguage(langCode: string) {
    let userLanguage = this.languages.find((l) => l.code == langCode);
    if (userLanguage) {
      this.selectedLanguage = userLanguage;
    }
    this.translationService.setCurrentLanguage(this.selectedLanguage);
    this.store.dispatch(new LoadMenu(this.selectedLanguage.code));
  }

  changeLanguage(lang: any): void {
    this.selectedLanguage = lang;
    this.translationService.setCurrentLanguage(lang);
    localStorage.setItem(this.languageKey, lang.code);
    window.dispatchEvent(new Event('languageChange'));
    this.store.dispatch(new LoadMenu(lang.code));
  }

  onNotificationClick(notification: UserNotification): void {
    if (notification.applicationTypeId && notification.appDataId) {
      this.router.navigate(['/app/applications'], {
        queryParams: {
          typeId: notification.applicationTypeId,
          highlightUuid: notification.appDataId,
        },
      });
    }
  }

  goToInbox(): void {
    this.router.navigate(['/app/inbox']);
  }

  logout(): void {
    this.authService.logout();
  }
}
